// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import aboutvideo from '../Assets/aboutvideo.mp4';

// const About = () => {
//     const [activeStat, setActiveStat] = useState(null);

//     // Core Studio Metrics
//     const studioStats = [
//         { value: '150+', label: 'Bespoke Spaces Crafted' },
//         { value: '8+', label: 'Years of Innovation' },
//         { value: '25+', label: 'Design Awards Won' }
//     ];

//     // Premium Pastel Studio Design Tokens
//     const theme = {
//         background: '#F8F6F2',    // Soft Alabaster White
//         surface: '#FFFFFF',       // Clean Pure White Base
//         accent: '#D4AF37',        // Champagne Gold Accent
//         textMain: '#2C302E',      // Charcoal Slate (High Readability Contrast)
//         textMuted: '#7A827E',     // Soft Muted Sage Grey
//         border: 'rgba(44, 48, 46, 0.08)' // Clean Subtle Boundary Lines
//     };

//     // Complex CSS Layout Animations
//     const animationStyles = `
//     @keyframes slideUpFade {
//       from { opacity: 0; transform: translateY(50px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     @keyframes lineExtend {
//       from { width: 0%; }
//       to { width: 100%; }
//     }
//     @keyframes subtleScale {
//       from { transform: scale(1.05); opacity: 0; }
//       to { transform: scale(1); opacity: 1; }
//     }
//     .animate-text-block { animation: slideUpFade 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//     .animate-line { animation: lineExtend 1.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//     .animate-image { animation: subtleScale 1.8s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//   `;

//     return (
//         <div style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             overflowX: 'hidden',
//             transition: 'background 0.5s ease'
//         }}>
//             <style>{animationStyles}</style>

//             {/* Navigation Return Anchor */}
//             {/* <Link to="/" style={{
//                 color: theme.textMuted,
//                 textDecoration: 'none',
//                 fontSize: '0.9rem',
//                 display: 'inline-block',
//                 marginBottom: '40px',
//                 transition: 'color 0.3s ease',
//                 letterSpacing: '1px'
//             }}
//                 onMouseEnter={(e) => e.target.style.color = theme.accent}
//                 onMouseLeave={(e) => e.target.style.color = theme.textMuted}>
//                 ← Back To Main Screen
//             </Link> */}

//             {/* Main Structural Asymmetric Container Split */}
//             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '60px', alignItems: 'stretch' }}>

//                 {/* ==================== LEFT ROW: STUDIO PHILOSOPHY ==================== */}
//                 <div className="animate-text-block" style={{ flex: '1.2', minWidth: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
//                     <div>
//                         <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '600' }}>
//                             The Architecture of Comfort
//                         </span>

//                         <h1 style={{ fontSize: '3.5rem', fontWeight: '300', margin: '15px 0 30px 0', letterSpacing: '1px', lineHeight: '1.1', color: theme.textMain }}>
//                             ST Studio is the manifest point where raw structure meets luxury soul.
//                         </h1>

//                         {/* Horizontal Graphic Divider Line */}
//                         <div className="animate-line" style={{ height: '1px', background: `linear-gradient(to right, ${theme.accent}, transparent)`, marginBottom: '30px' }} />

//                         <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: theme.textMuted, maxWidth: '600px', marginBottom: '20px' }}>
//                             We don't simply style rooms; we redesign human movement parameters. By calculating raw architectural vectors, balancing natural luminosity patterns, and layering custom bespoke organic textures, we generate spaces that function as quiet extensions of your sub-conscious state.
//                         </p>

//                         <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: theme.textMuted, maxWidth: '600px' }}>
//                             Based out of Pune, our team of structural draftsmen and design artisans cross-engineer luxury spatial layouts to reflect the physical rhythm of your daily routine.
//                         </p>
//                     </div>

//                     {/* Interactive Metric Cards Row Container */}
//                     <div style={{ display: 'flex', gap: '20px', marginTop: '50px', flexWrap: 'wrap' }}>
//                         {studioStats.map((stat, idx) => {
//                             const isCardHovered = activeStat === idx;
//                             return (
//                                 <div
//                                     key={idx}
//                                     onMouseEnter={() => setActiveStat(idx)}
//                                     onMouseLeave={() => setActiveStat(null)}
//                                     style={{
//                                         flex: '1',
//                                         minWidth: '140px',
//                                         background: isCardHovered ? 'rgba(212, 175, 55, 0.05)' : theme.surface,
//                                         border: `1px solid ${isCardHovered ? theme.accent : theme.border}`,
//                                         padding: '25px 20px',
//                                         borderRadius: '12px',
//                                         textAlign: 'center',
//                                         transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                                         transform: isCardHovered ? 'translateY(-8px)' : 'translateY(0)',
//                                         boxShadow: isCardHovered ? '0 15px 35px rgba(44, 48, 46, 0.06)' : 'none'
//                                     }}
//                                 >
//                                     <h3 style={{
//                                         fontSize: '2.2rem',
//                                         fontWeight: '700',
//                                         margin: '0 0 5px 0',
//                                         color: isCardHovered ? theme.accent : theme.textMain,
//                                         transition: 'color 0.3s'
//                                     }}>
//                                         {stat.value}
//                                     </h3>
//                                     <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '1px', lineHeight: '1.3' }}>
//                                         {stat.label}
//                                     </p>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>

//                 {/* ==================== RIGHT ROW: VISUAL PREVIEW DISPLAY ==================== */}
//                 <div className="animate-image" style={{
//                     flex: '0.9',
//                     minWidth: '320px',
//                     position: 'relative',
//                     borderRadius: '24px',
//                     overflow: 'hidden',
//                     background: theme.surface,
//                     height: '600px',
//                     boxShadow: '0 20px 45px rgba(44, 48, 46, 0.05)',
//                     border: `1px solid ${theme.border}`
//                 }}>
//                     <video
//                         autoPlay
//                         loop
//                         muted
//                         playsInline
//                         style={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover'
//                         }}
//                     >
//                         <source src={aboutvideo} type="video/mp4" />
//                         Your browser does not support the video tag.
//                     </video>

//                     {/* Soft Protective Light Overlay for Typography Overlay Readability */}
//                     <div style={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         background: 'linear-gradient(to top, rgba(248, 246, 242, 0.85) 0%, rgba(248, 246, 242, 0.05) 50%)',
//                         pointerEvents: 'none'
//                     }} />

//                     {/* Floating Luxury Geometric Overlay Card */}
//                     <div style={{
//                         position: 'absolute',
//                         bottom: '30px',
//                         left: '30px',
//                         right: '30px',
//                         background: 'rgba(255, 255, 255, 0.9)',
//                         backdropFilter: 'blur(15px)',
//                         border: `1px solid ${theme.border}`,
//                         padding: '30px',
//                         borderRadius: '16px',
//                         zIndex: 2
//                     }}>
//                         <h4 style={{ margin: '0 0 10px 0', fontSize: '1.2rem', fontWeight: '400', letterSpacing: '0.5px', color: theme.textMain }}>
//                             "Simplicity is the ultimate sophistication."
//                         </h4>
//                         <p style={{ margin: '0', fontSize: '0.85rem', color: theme.accent, textTransform: 'uppercase', letterSpacing: '2px' }}>
//                             — Leonardo da Vinci
//                         </p>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default About;


// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import aboutvideo from '../Assets/aboutvideo.mp4';


// const About = () => {
//     const [activeStat, setActiveStat] = useState(null);


//     // Core Studio Metrics
//     const studioStats = [
//         { value: '150+', label: 'Bespoke Spaces Crafted' },
//         { value: '8+', label: 'Years of Innovation' },
//         { value: '25+', label: 'Design Awards Won' }
//     ];

//     // Premium Pastel Studio Design Tokens
//     const theme = {
//         background: '#F8F6F2',    // Soft Alabaster White
//         surface: '#FFFFFF',       // Clean Pure White Base
//         accent: '#D4AF37',        // Champagne Gold Accent
//         textMain: '#2C302E',      // Charcoal Slate (High Readability Contrast)
//         textMuted: '#7A827E',     // Soft Muted Sage Grey
//         border: 'rgba(44, 48, 46, 0.08)' // Clean Subtle Boundary Lines
//     };




//     // Advanced Layout Responsive CSS Injections
//     const animationStyles = `
//     @keyframes slideUpFade {
//       from { opacity: 0; transform: translateY(50px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     @keyframes lineExtend {
//       from { width: 0%; }
//       to { width: 100%; }
//     }
//     @keyframes subtleScale {
//       from { transform: scale(1.05); opacity: 0; }
//       to { transform: scale(1); opacity: 1; }
//     }
//     .animate-text-block { animation: slideUpFade 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//     .animate-line { animation: lineExtend 1.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//     .animate-image { animation: subtleScale 1.8s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

//     /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
//     @media (max-width: 768px) {
//         .about-screen-container { padding: 30px 20px !important; }
//         .about-asymmetric-split { gap: 40px !important; }
//         .about-main-title { font-size: 2.2rem !important; margin: 10px 0 20px 0 !important; }

//         /* Forces metrics layout to form a flexible double-column or uniform strip on small displays */
//         .about-stats-grid { gap: 15px !important; margin-top: 35px !important; }
//         .about-stat-card { min-width: 120px !important; padding: 20px 15px !important; }
//         .about-stat-card h3 { font-size: 1.8rem !important; }

//         /* Re-calibrates vertical visual container space constraints */
//         .about-visual-frame { height: 380px !important; border-radius: 16px !important; }
//         .about-quote-box { padding: 20px !important; bottom: 20px !important; left: 20px !important; right: 20px !important; }
//         .about-quote-box h4 { font-size: 1rem !important; }
//     }
//   `;



//     return (
//         <div className="about-screen-container" style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box',
//             overflowX: 'hidden',
//             transition: 'background 0.5s ease'
//         }}>
//             <style>{animationStyles}</style>

//             {/* Navigation Return Anchor */}
//             {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
//                 <Link to="/" style={{
//                     color: theme.textMuted,
//                     textDecoration: 'none',
//                     fontSize: '0.9rem',
//                     display: 'inline-block',
//                     transition: 'color 0.3s ease',
//                     letterSpacing: '1px'
//                 }}
//                     onMouseEnter={(e) => e.target.style.color = theme.accent}
//                     onMouseLeave={(e) => e.target.style.color = theme.textMuted}>
//                     ← Back To Main Screen
//                 </Link>
//                 <span style={{ fontSize: '0.8rem', color: theme.textMuted, letterSpacing: '2px', textTransform: 'uppercase' }}>
//                     ST Interior Studio
//                 </span>
//             </div> */}

//             {/* Main Structural Asymmetric Container Split */}
//             <div className="about-asymmetric-split" style={{ display: 'flex', flexWrap: 'wrap', gap: '60px', alignItems: 'stretch' }}>

//                 {/* ==================== LEFT ROW: STUDIO PHILOSOPHY ==================== */}
//                 <div className="animate-text-block" style={{ flex: '1.2', minWidth: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
//                     <div>
//                         <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '600' }}>
//                             The Architecture of Comfort
//                         </span>

//                         <h1 className="about-main-title" style={{ fontSize: '3.5rem', fontWeight: '300', margin: '15px 0 30px 0', letterSpacing: '1px', lineHeight: '1.1', color: theme.textMain }}>
//                             ST Studio is the manifest point where raw structure meets luxury soul.
//                         </h1>

//                         {/* Horizontal Graphic Divider Line */}
//                         <div className="animate-line" style={{ height: '1px', background: `linear-gradient(to right, ${theme.accent}, transparent)`, marginBottom: '30px' }} />

//                         <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: theme.textMuted, maxWidth: '600px', marginBottom: '20px' }}>
//                             We don't simply style rooms; we redesign human movement parameters. By calculating raw architectural vectors, balancing natural luminosity patterns, and layering custom bespoke organic textures, we generate spaces that function as quiet extensions of your sub-conscious state.
//                         </p>

//                         <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: theme.textMuted, maxWidth: '600px' }}>
//                             Based out of Pune, our team of structural draftsmen and design artisans cross-engineer luxury spatial layouts to reflect the physical rhythm of your daily routine.
//                         </p>
//                     </div>

//                     {/* Interactive Metric Cards Row Container */}
//                     <div className="about-stats-grid" style={{ display: 'flex', gap: '20px', marginTop: '50px', flexWrap: 'wrap' }}>
//                         {studioStats.map((stat, idx) => {
//                             const isCardHovered = activeStat === idx;
//                             return (
//                                 <div
//                                     key={idx}
//                                     className="about-stat-card"
//                                     onMouseEnter={() => setActiveStat(idx)}
//                                     onMouseLeave={() => setActiveStat(null)}
//                                     style={{
//                                         flex: '1',
//                                         minWidth: '140px',
//                                         background: isCardHovered ? 'rgba(212, 175, 55, 0.05)' : theme.surface,
//                                         border: `1px solid ${isCardHovered ? theme.accent : theme.border}`,
//                                         padding: '25px 20px',
//                                         borderRadius: '12px',
//                                         textAlign: 'center',
//                                         transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                                         transform: isCardHovered ? 'translateY(-8px)' : 'translateY(0)',
//                                         boxShadow: isCardHovered ? '0 15px 35px rgba(44, 48, 46, 0.06)' : 'none'
//                                     }}
//                                 >
//                                     <h3 style={{
//                                         fontSize: '2.2rem',
//                                         fontWeight: '700',
//                                         margin: '0 0 5px 0',
//                                         color: isCardHovered ? theme.accent : theme.textMain,
//                                         transition: 'color 0.3s'
//                                     }}>
//                                         {stat.value}
//                                     </h3>
//                                     <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '1px', lineHeight: '1.3' }}>
//                                         {stat.label}
//                                     </p>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>

//                 {/* ==================== RIGHT ROW: VISUAL PREVIEW DISPLAY ==================== */}
//                 <div className="animate-image about-visual-frame" style={{
//                     flex: '0.9',
//                     minWidth: '320px',
//                     position: 'relative',
//                     borderRadius: '24px',
//                     overflow: 'hidden',
//                     background: theme.surface,
//                     height: '600px',
//                     boxShadow: '0 20px 45px rgba(44, 48, 46, 0.05)',
//                     border: `1px solid ${theme.border}`
//                 }}>
//                     <video
//                         autoPlay
//                         loop
//                         muted
//                         playsInline
//                         style={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover'
//                         }}
//                     >
//                         <source src={aboutvideo} type="video/mp4" />
//                         Your browser does not support the video tag.
//                     </video>

//                     {/* Soft Protective Light Overlay for Typography Overlay Readability */}
//                     <div style={{
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         background: 'linear-gradient(to top, rgba(248, 246, 242, 0.85) 0%, rgba(248, 246, 242, 0.05) 50%)',
//                         pointerEvents: 'none'
//                     }} />

//                     {/* Floating Luxury Geometric Overlay Card */}
//                     <div className="about-quote-box" style={{
//                         position: 'absolute',
//                         bottom: '30px',
//                         left: '30px',
//                         right: '30px',
//                         background: 'rgba(255, 255, 255, 0.9)',
//                         backdropFilter: 'blur(15px)',
//                         border: `1px solid ${theme.border}`,
//                         padding: '30px',
//                         borderRadius: '16px',
//                         zIndex: 2
//                     }}>
//                         <h4 style={{ margin: '0 0 10px 0', fontSize: '1.2rem', fontWeight: '400', letterSpacing: '0.5px', color: theme.textMain }}>
//                             "Simplicity is the ultimate sophistication."
//                         </h4>
//                         <p style={{ margin: '0', fontSize: '0.85rem', color: theme.accent, textTransform: 'uppercase', letterSpacing: '2px' }}>
//                             — Leonardo da Vinci
//                         </p>
//                     </div>
//                 </div>

//             </div>

//         </div>
//     );
// };

// export default About;




import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import aboutvideo from '../Assets/aboutvideo.mp4';

import Häfelelogo from '../Assets/brandimage/Häfelelogo.png';
import Hettichlogo from '../Assets/brandimage/Hettichlogo.png';
import Godrejlogo from '../Assets/brandimage/Godrejlogo.png';
import CenturyPlylogo from '../Assets/brandimage/CenturyPlylogo.png';
import Blumlogo from '../Assets/brandimage/Blumlogo.png';
import AsianPaintslogo from '../Assets/brandimage/asianpaintlogo.png';
import Greenplylogo from '../Assets/brandimage/greenply.png';
import Jaquarlogo from '../Assets/brandimage/Jaquarlogo.png';
import SaintGobainlogo from '../Assets/brandimage/SaintGobainlogo.png';
// import Sleeklogo from '../Assets/brandimage/sleek.png';
import Ikealogo from '../Assets/brandimage/IKEAlogo.png';

const About = () => {
    const [activeStat, setActiveStat] = useState(null);
    const [hoveredBadgeIdx, setHoveredBadgeIdx] = useState(null);

    // Core Studio Metrics
    const studioStats = [
        { value: '50+', label: 'Bespoke Spaces Crafted' },
        { value: '7+', label: 'Years of Innovation' },
        { value: '10+', label: 'Design Awards Won' }
    ];

    // Image-Accurate Why Choose Us Checklists
    const checklistData = [
        {
            id: 1,
            title: "A great option for busy folks.",
            desc: "Looking up interior designer in Pune to execute your ideas? ST Studio is the perfect answer for busy individuals like yourself. We offer services from the initial design stage to the final on-site execution. With our team of professionals, we are well equipped to bring your ideas to life efficiently, leaving you stress-free!"
        },
        {
            id: 2,
            title: "Smart budget optimization.",
            desc: "Need an expert interior designer in Pune who can help you optimize your budget? Our team is comprised of expert professionals who can advise how to best spend or not spend money before any purchases are made. We understand how important it is to be on a budget; we make sure your funds are used optimally!"
        },
        {
            id: 3,
            title: "Top notch after-sale service.",
            desc: "We are committed to cultivating strong relationships with our clients. We pride ourselves on providing exemplary after-sale service and unwavering support. Our products are built to last, however, if replacement is needed, we send a team right away; this has earned us the reputation of most trusted interior designer in Pune."
        }
    ];

    // Image-Accurate Lower Grid Feature Icon Badges
    const minorBadges = [
        { id: 1, icon: "✏️", text: "Get Tailored One of a Kind Design Options" },
        { id: 2, icon: "⏳", text: "Receive Handover on Agreed Time" },
        { id: 3, icon: "💡", text: "Get Exclusive Décor Lists from E-Stores" },
        { id: 4, icon: "🚛", text: "Move Ready Support for NRIs*" },
        { id: 5, icon: "📋", text: "Obtain Transparent Modular Estimates" },
        { id: 6, icon: "📜", text: "Enjoy Exceptional 5-Year Warranty*" },
        { id: 7, icon: "📐", text: "Experience Design Evolved in 3D" },
        { id: 8, icon: "🧴", text: "Move In Deep Cleaned Cozy Home" }
    ];

    // Brands We Trust Ecosystem Dataset
    const trustedBrands = [
        { id: 1, name: 'Häfele', type: 'Premium Hardware', img: Häfelelogo },
        { id: 2, name: 'Hettich', type: 'Intelligent Fittings', img: Hettichlogo },
        { id: 3, name: 'Godrej', type: 'Security Systems', img: Godrejlogo },
        { id: 4, name: 'CenturyPly', type: 'Structural Boarding', img: CenturyPlylogo },
        { id: 5, name: 'Blum', type: 'Motion Mechanism', img: Blumlogo },
        { id: 6, name: 'Asian Paints', type: 'Pastel Pigments', img: AsianPaintslogo },
        // NEW ACCREDITED BRANDS ADDED:
        { id: 7, name: 'Greenply', type: 'Eco-Friendly Plywood', img: Greenplylogo },
        { id: 8, name: 'Jaquar', type: 'Luxury Bath Fittings', img: Jaquarlogo },
        { id: 9, name: 'Saint-Gobain', type: 'Premium Glass Architecture', img: SaintGobainlogo },
        // { id: 10, name: 'Sleek By Asian Paints', type: 'Modular Kitchen Systems', img: Sleeklogo },
        { id: 11, name: 'IKEA', type: 'Scandinavian Modular Decor', img: Ikealogo }
    ];

    // Premium Pastel Studio Design Tokens
    const theme = {
        background: '#FFFFFF',
        surface: '#FFFFFF',
        accent: '#D4AF37',
        checkColor: '#4BB543',
        textMain: '#2C302E',
        textMuted: '#7A827E',
        border: 'rgba(44, 48, 46, 0.08)'
    };

    // Advanced Layout Responsive CSS Injections
    const animationStyles = `
    @keyframes slideUpFade {
      from { opacity: 0; transform: translateY(50px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes lineExtend {
      from { width: 0%; }
      to { width: 100%; }
    }
    @keyframes subtleScale {
      from { transform: scale(1.05); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }
    @keyframes loopMarquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    .animate-text-block { animation: slideUpFade 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .animate-line { animation: lineExtend 1.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .animate-image { animation: subtleScale 1.8s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .animate-marquee-track { display: flex; width: max-content; animation: loopMarquee 25s linear infinite; }
    .animate-marquee-track:hover { animation-play-state: paused; }

    /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
    @media (max-width: 991px) {
        .about-screen-container { padding: 30px 20px !important; }
        .about-asymmetric-split, .why-choose-split { flex-direction: column !important; gap: 40px !important; }
        .about-left-block, .why-choose-left { min-width: 100% !important; flex: none !important; }
        .about-main-title, .why-choose-title { font-size: 2.2rem !important; margin: 10px 0 20px 0 !important; }
        
        .about-stats-grid { gap: 15px !important; margin-top: 35px !important; }
        .about-stat-card { min-width: 120px !important; padding: 20px 15px !important; }
        .about-stat-card h3 { font-size: 1.8rem !important; }

        .about-visual-frame { height: 380px !important; border-radius: 16px !important; min-width: 100% !important; flex: none !important; }
        .about-quote-box { padding: 20px !important; bottom: 20px !important; left: 20px !important; right: 20px !important; }
        .about-quote-box h4 { font-size: 1rem !important; }
        
        .minor-badges-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 25px 15px !important; }
        .brand-marquee-window { display: none !important; }
        .brand-grid-fallback { display: grid !important; grid-template-columns: repeat(2, 1fr) !important; gap: 15px !important; }
    }
  `;

    return (
        <div className="about-screen-container" style={{
            background: theme.background,
            minHeight: '100vh',
            color: theme.textMain,
            padding: '40px 60px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            boxSizing: 'border-box',
            overflowX: 'hidden',
            transition: 'background 0.5s ease'
        }}>
            <style>{animationStyles}</style>



            {/* ==================== SECTION 1: STUDIO PHILOSOPHY (ORIGINAL ABOUT) ==================== */}
            <div className="about-asymmetric-split" style={{ display: 'flex', flexWrap: 'wrap', gap: '60px', alignItems: 'stretch', marginBottom: '100px' }}>

                {/* LEFT ROW: TEXT PHILOSOPHY */}
                <div className="animate-text-block about-left-block" style={{ flex: '1.2', minWidth: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div>
                        <div style={{ display: "flex", justifyContent: "center" }}>


                            {/* <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '600' }}>
                                The Architecture of Comfort
                            </span> */}

                            {/* <h1 className="about-main-title" style={{ fontFamily: "'Cinzel', Georgia, serif", fontSize: '3.5rem', fontWeight: '300', margin: '15px 0 30px 0', letterSpacing: '1px', lineHeight: '1.1', color: theme.textMain, }}>
                            ST Studio is the manifest point where raw structure meets luxury soul.
                        </h1> */}
                            <h1 className="about-main-title" style={{ fontFamily: "'Cinzel', Georgia, serif", fontSize: '2.5rem', fontWeight: '300', margin: '15px 0 30px 0', letterSpacing: '1px', lineHeight: '1.1', color: theme.textMain, }}>
                                know Us
                            </h1>
                        </div>
                        <div className="animate-line" style={{ height: '1px', background: `linear-gradient(to right, ${theme.accent}, transparent)`, marginBottom: '30px' }} />

                        <p style={{
                            lineHeight: '1.8', marginBottom: '20px', color: "#1A1C1B",

                            fontSize: "clamp(20px, 1.2vw, 17px)",
                            fontFamily: "'Cormorant Garamond', serif",

                            textAlign: "center",
                            fontWeight: '400',
                            letterSpacing: '1px',
                            margin: "0 0 35px 0",
                        }}>
                            STInterior Studio was founded in 11:11. The studio undertakes architecture and interior design project dedicated to crafting timeless residential and commercial environments that embody refined living. Every space we create begins with a deep understanding of our clients, their aspirations, and the way they experience the world. Guided by a philosophy of thoughtful design, we believe each project deserves its own identity—one that harmoniously balances our design vision with the individuality of those who inhabit it.With an unwavering focus on detail, materiality, and craftsmanship, we oversee every stage of the design journey, from concept to completion.

                        </p>

                        <p style={{
                            color: "#1A1C1B",
                            lineHeight: '1.8',
                            fontSize: "clamp(20px, 1.2vw, 17px)",
                            fontFamily: "'Cormorant Garamond', serif",
                            textAlign: "center",

                            fontWeight: '400',
                            letterSpacing: '1px',
                            margin: "0 0 35px 0",
                        }}>
                            Supported by a trusted network of skilled artisans, consultants, and execution partners, we transform carefully considered ideas into enduring spaces that are elegant, purposeful, and deeply personal.
                        </p>
                        <p style={{
                            color: "#1A1C1B",
                            lineHeight: '1.8',
                            fontSize: "clamp(20px, 1.2vw, 17px)",
                            fontFamily: "'Cormorant Garamond', serif",
                            textAlign: "center",

                            fontWeight: '400',
                            letterSpacing: '1px',
                            margin: "0 0 35px 0",
                        }}>
                            At STInterior Studio, we believe exceptional design is not simply seen—it is felt, experienced, and lived.

                        </p>

                        <p style={{
                            color: "#1A1C1B",
                            lineHeight: '1.8',
                            fontSize: "clamp(20px, 1.2vw, 17px)",
                            fontFamily: "'Cormorant Garamond', serif",
                            textAlign: "center",

                            fontWeight: '400',
                            letterSpacing: '1px',
                            margin: "0 0 35px 0",
                        }}>
                            We approach every project as a collaborative journey, where trust, creativity, and precision shape spaces that resonate beyond aesthetics.Our design philosophy is rooted in creating environments that seamlessly unite architecture, interiors, and the emotions they inspire.We believe that timeless spaces are born through meaningful dialogue, thoughtful planning, and an uncompromising commitment to quality considering clients and our vision.


                        </p>

                        <p style={{
                            color: "#1A1C1B",
                            lineHeight: '1.8',
                            fontSize: "clamp(20px, 1.2vw, 17px)",
                            fontFamily: "'Cormorant Garamond', serif",
                            textAlign: "center",

                            fontWeight: '400',
                            letterSpacing: '1px',
                            margin: "0 0 35px 0",
                        }}>

                        </p>

                        <p style={{
                            color: "#1A1C1B",
                            lineHeight: '1.8',
                            fontSize: "clamp(20px, 1.2vw, 17px)",
                            fontFamily: "'Cormorant Garamond', serif",
                            textAlign: "center",

                            fontWeight: '400',
                            letterSpacing: '1px',
                            margin: "0 0 35px 0",
                        }}>
                            Every material is carefully selected, every proportion thoughtfully considered, and every detail intentionally crafted to create a harmonious .We focus on creating designs that remain elegant, relevant, and enduring through time.Our work celebrates the beauty of simplicity, where understated luxury and refined craftsmanship define every experience.
                            Each project reflects a unique narrative, thoughtfully curated to express the personality, aspirations, and lifestyle of its occupants .We value authenticity in design, ensuring every space possesses a distinct identity while maintaining a timeless sense of sophistication.From the first sketch to the final detail, we remain dedicated to delivering spaces that balance functionality with effortless elegance.
                        </p>

                        <p style={{
                            color: "#1A1C1B",
                            lineHeight: '1.8',
                            fontSize: "clamp(20px, 1.2vw, 17px)",
                            fontFamily: "'Cormorant Garamond', serif",
                            textAlign: "center",

                            fontWeight: '400',
                            letterSpacing: '1px',
                            margin: "0 0 35px 0",
                        }}>
                            Our commitment extends beyond design—we cultivate lasting relationships built on trust, transparency, and meticulous attention to every stage of the journey.Every completed project stands as a testament to our passion for creating spaces that inspire, enrich daily living, and leave a lasting impression.
                        </p>
                    </div>

                    {/* Interactive Metric Cards Container */}
                    {/* <div className="about-stats-grid" style={{ display: 'flex', gap: '20px', marginTop: '50px', flexWrap: 'wrap' }}>
                        {studioStats.map((stat, idx) => {
                            const isCardHovered = activeStat === idx;
                            return (
                                <div
                                    key={idx}
                                    className="about-stat-card"
                                    onMouseEnter={() => setActiveStat(idx)}
                                    onMouseLeave={() => setActiveStat(null)}
                                    style={{
                                        flex: '1',
                                        minWidth: '140px',
                                        background: isCardHovered ? 'rgba(212, 175, 55, 0.05)' : theme.surface,
                                        border: `1px solid ${isCardHovered ? theme.accent : theme.border}`,
                                        padding: '25px 20px',
                                        borderRadius: '12px',
                                        textAlign: 'center',
                                        transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                                        transform: isCardHovered ? 'translateY(-8px)' : 'translateY(0)',
                                        boxShadow: isCardHovered ? '0 15px 35px rgba(44, 48, 46, 0.06)' : 'none'
                                    }}
                                >
                                    <h3 style={{
                                        fontSize: '2.2rem',
                                        fontWeight: '700',
                                        margin: '0 0 5px 0',
                                        color: isCardHovered ? theme.accent : theme.textMain,
                                        transition: 'color 0.3s'
                                    }}>
                                        {stat.value}
                                    </h3>
                                    <p style={{ margin: '0', fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '1px', lineHeight: '1.3' }}>
                                        {stat.label}
                                    </p>
                                </div>
                            );
                        })}
                    </div> */}
                </div>

                {/* RIGHT ROW: VISUAL STUDIO REEL VIDEO DISPLAY */}
                {/* <div className="animate-image about-visual-frame" style={{
                    flex: '0.9',
                    minWidth: '320px',
                    position: 'relative',
                    borderRadius: '24px',
                    overflow: 'hidden',
                    background: theme.surface,
                    height: '600px',
                    boxShadow: '0 20px 45px rgba(44, 48, 46, 0.05)',
                    border: `1px solid ${theme.border}`
                }}>
                    <video autoPlay loop muted playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
                        <source src={aboutvideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(248, 246, 242, 0.85) 0%, rgba(248, 246, 242, 0.05) 50%)', pointerEvents: 'none' }} />

                    <div className="about-quote-box" style={{ position: 'absolute', bottom: '30px', left: '30px', right: '30px', background: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(15px)', border: `1px solid ${theme.border}`, padding: '30px', borderRadius: '16px', zIndex: 2 }}>
                        <h4 style={{ margin: '0 0 10px 0', fontSize: '1.2rem', fontWeight: '400', letterSpacing: '0.5px', color: theme.textMain, fontFamily: "'Lora', serif" }}>
                            "Simplicity is the ultimate sophistication."
                        </h4>
                        <p style={{ margin: '0', fontSize: '0.85rem', color: theme.accent, textTransform: 'uppercase', letterSpacing: '2px' }}>
                            — Leonardo da Vinci
                        </p>
                    </div>
                </div> */}
            </div>

            {/* ==================== SECTION 2: WHY CHOOSE US (IMAGE BALANCED LAYOUT) ==================== */}
            {/* <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '80px', marginBottom: '80px' }}>
                <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                    <h2 className="why-choose-title" style={{ fontSize: '2.4rem', fontWeight: '400', color: theme.textMain, letterSpacing: '1px', margin: 0, textTransform: 'uppercase' }}>
                        Why Choose Our Interior Designers?
                    </h2>
                    <div style={{ width: '40px', height: '2px', background: theme.accent, margin: '15px auto 0 auto' }} />
                </div>

                <div className="why-choose-split" style={{ display: 'flex', gap: '60px', alignItems: 'flex-start' }}>
                    
                    <div className="why-choose-left" style={{ flex: '1.2', minWidth: '320px', display: 'flex', flexDirection: 'column', gap: '35px' }}>
                        {checklistData.map((item) => (
                            <div key={item.id} className="animate-text-block" style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                                <div style={{ color: '#FFFFFF', background: theme.checkColor, fontSize: '0.85rem', fontWeight: 'bold', width: '20px', height: '20px', borderRadius: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0, marginTop: '4px' }}>
                                    ✓
                                </div>
                                <div>
                                    <h3 style={{ margin: '0 0 10px 0', fontSize: '1.25rem', fontWeight: '600', color: theme.textMain, letterSpacing: '0.3px' }}>{item.title}</h3>
                                    <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.6', color: theme.textMuted }}>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    
                    <div className="why-choose-left" style={{ flex: '1', minWidth: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <p style={{ margin: '0 0 20px 0', fontSize: '1.1rem', lineHeight: '1.7', color: theme.textMuted, fontStyle: 'italic' }}>
                            "Designing spaces isn't about filling rooms; it's about engineering functional freedom."
                        </p>
                        <div style={{ width: '100%', height: '1px', background: theme.border, marginBottom: '20px' }} />
                        <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '3px', fontSize: '0.8rem', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Quality Seals</span>
                        <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.6', color: theme.textMuted }}>
                            Every single execution module lifecycle undergoes rigid double-layer micro-tolerance audits. We guarantee alignment between high-fidelity 3D modeling stages and physical structural realities.
                        </p>
                    </div>
                </div>
            </div> */}

            {/* ==================== SECTION 3: 2-ROW MINIMALIST MICRO-FEATURE BADGES ==================== */}
            {/* <div className="animate-text-block" style={{ marginBottom: '90px', borderTop: `1px solid ${theme.border}`, paddingTop: '60px' }}>
                <div className="minor-badges-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '40px 30px', textAlign: 'center' }}>
                    {minorBadges.map((badge, index) => {
                        const isHovered = hoveredBadgeIdx === index;
                        return (
                            <div key={badge.id} onMouseEnter={() => setHoveredBadgeIdx(index)} onMouseLeave={() => setHoveredBadgeIdx(null)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', padding: '10px', transform: isHovered ? 'translateY(-4px)' : 'translateY(0)', transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)' }}>
                                <div style={{ fontSize: '1.6rem', background: isHovered ? 'rgba(214, 175, 55, 0.05)' : theme.surface, border: `1px solid ${isHovered ? theme.accent : theme.border}`, width: '60px', height: '60px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 4px 15px rgba(0,0,0,0.01)', transition: 'all 0.3s ease' }}>
                                    {badge.icon}
                                </div>
                                <p style={{ margin: 0, fontSize: '0.9rem', fontWeight: '500', lineHeight: '1.4', color: isHovered ? theme.accent : theme.textMain, maxWidth: '180px', transition: 'color 0.3s' }}>
                                    {badge.text}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div> */}

            {/* ==================== SECTION 4: BRANDS WE TRUST SCROLLING DECK MARQUEE ==================== */}
            {/* <div className="animate-text-block" style={{ width: '100%', margin: '0' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '3px', fontSize: '0.8rem', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Ecosystem Partners</span>
                    <h2 style={{ fontSize: '1.6rem', fontWeight: '400', margin: '0', letterSpacing: '0.5px' }}>Brands We Trust</h2>
                </div>

                
                <div className="brand-marquee-window" style={{ position: 'relative', width: '100vw', margin: '0 -60px', overflow: 'hidden', background: theme.surface, padding: '25px 0', borderTop: `1px solid ${theme.border}`, borderBottom: `1px solid ${theme.border}` }}>
                    <div className="animate-marquee-track">
                        {[...trustedBrands, ...trustedBrands].map((brand, idx) => (
                            <div key={idx} style={{ width: '190px', padding: '0 25px', display: 'flex', alignItems: 'center', gap: '15px', flexShrink: 0, borderRight: `1px solid rgba(44, 48, 46, 0.05)` }}>
                                <img src={brand.img} alt={brand.name} style={{ height: '36px', width: '36px', borderRadius: '6px', objectFit: 'contain', transition: 'all 0.3s' }} onMouseEnter={(e) => e.target.style.filter = 'grayscale(0%) opacity(100%)'} onMouseLeave={(e) => e.target.style.filter = 'grayscale(100%) opacity(75%)'} />
                                <div style={{ textAlign: 'left' }}>
                                    <span style={{ fontSize: '0.85rem', fontWeight: '600', color: theme.textMain, display: 'block', whiteSpace: 'nowrap' }}>{brand.name}</span>
                                    <span style={{ fontSize: '0.7rem', color: theme.textMuted, display: 'block', whiteSpace: 'nowrap' }}>{brand.type}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            
                <div className="brand-grid-fallback" style={{ display: 'none' }}>
                    {trustedBrands.map((brand) => (
                        <div key={brand.id} style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: '12px', padding: '15px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src={brand.img} alt={brand.name} style={{ height: '35px', width: '35px', borderRadius: '6px', objectFit: 'contain', marginBottom: '8px' }} />
                            <span style={{ fontSize: '0.85rem', fontWeight: '600', color: theme.textMain }}>{brand.name}</span>
                            <span style={{ fontSize: '0.7rem', color: theme.textMuted }}>{brand.type}</span>
                        </div>
                    ))}
                </div>
            </div> */}





        </div>
    );
};

export default About;
